import { Content } from '@prismicio/client';
import { Simplify } from '../../../../prismicio-types';
import { PrismicNextImage } from '@prismicio/next';
import { RoundArrowUp } from '@/assets/icons/RoundArrowUp';
import WhiteCheckmark from '@/assets/icons/WhiteCheckmark';
import styles from './FiveLakesImageContent.module.scss';

interface Props {
  data: Simplify<Content.PartnerHeroSliceFiveLakesPrimary>;
}

const FiveLakesImageContent = ({ data }: Props) => {
  return (
    <>
      <div className={styles.leftColumn}>
        <div className={styles.infoBlocksWrapper}>
          <div className={styles.topInfoBlock}>
            <div className={styles.topInfoBlockHead}>
              <span className={styles.topInfoBlockTitle}>{data.infotitle}</span>
              <WhiteCheckmark className={styles.topInfoBlockIcon} />
            </div>
            <p className={styles.topInfoBlockValue}>{data.infovalue}</p>
          </div>
          <div className={`${styles.topInfoBlock} ${styles.bottomInfoBlock}`}>
            <div className={styles.topInfoBlockHead}>
              <span className={styles.topInfoBlockTitle}>{data.infolabel}</span>
              <div className={styles.iconWrapper}>
                <RoundArrowUp className={styles.bottomInfoBlockIcon} />
              </div>
            </div>
            <p className={styles.topInfoBlockValue}>{data.infolabelvalue}</p>
          </div>
        </div>
        <PrismicNextImage field={data.partnerlogo} className={styles.logo} />
      </div>
      <PrismicNextImage field={data.personimg} className={styles.personImg} />
    </>
  );
};

export default FiveLakesImageContent;
